import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M37.28 108.8c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10a4 4 0 0 0-4 4c0 2.21 1.79 4 4 4s4-1.79 4-4a4 4 0 0 0-4-4"
    />
    <path fill="#D8FFFF" d="M19.92 70.81a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="M88.69 18.2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M17.79 91.18l3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM105.58 31.8h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V34.8h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M30 41.8v44.85C30 88.5 31.53 90 33.43 90h49.15c1.89 0 3.43-1.5 3.43-3.35V41.8z"
    />
    <path
      fill="#0597A3"
      d="M86 29.35C86 27.5 84.47 26 82.57 26H33.42c-1.89 0-3.43 1.5-3.43 3.35V41.8h56V29.35z"
    />
    <path
      fill="#00D8D8"
      d="M41 34.25c-1.24 0-2.25-1.01-2.25-2.25V22c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v10c0 1.24-1.01 2.25-2.25 2.25M58 34.25c-1.24 0-2.25-1.01-2.25-2.25V22c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v10c0 1.24-1.01 2.25-2.25 2.25M75 34.25c-1.24 0-2.25-1.01-2.25-2.25V22c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v10c0 1.24-1.01 2.25-2.25 2.25"
    />
    <path
      fill="#001A43"
      d="M45.56 62.35c-.58 0-1.15-.22-1.59-.66l-4.29-4.29c-.88-.88-.88-2.3 0-3.18s2.3-.88 3.18 0l2.7 2.7 6.36-6.36c.88-.88 2.3-.88 3.18 0s.88 2.3 0 3.18l-7.96 7.95c-.44.44-1.02.66-1.59.66zM45.56 78.22c-.58 0-1.15-.22-1.59-.66l-4.29-4.29c-.88-.88-.88-2.3 0-3.18s2.3-.88 3.18 0l2.7 2.7 6.36-6.36c.88-.88 2.3-.88 3.18 0s.88 2.3 0 3.18l-7.96 7.95c-.44.44-1.02.66-1.59.66zM74 59.25H62c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h12c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M74 74.25H62c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h12c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25"
    />
  </svg>
);
const SvgEnrichedIconToDosBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconToDosBrand);
export default Memo;
